import React from 'react';
import logo from './logo.svg';
import { BrowserRouter, HashRouter, Route, Routes} from "react-router-dom";
import './App.css';
import Home from './pages/Home';
function App() {
  return (
    <HashRouter >
      <div className="App">
          <Routes>
             <Route path='/' element={<Home />} />
          </Routes>
      </div>
    </HashRouter>
    
  );
}

export default App;
